import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {ClientActivityLogContent} from "./ClientActivityLogContent";
import {withRouterParams} from "../../utils/withRouterParams";

export class ClientActivityLog extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <ClientActivityLogContent clientId={this.props.match.params.id}/>
            </div>
        )
    }
}

export default withRouterParams(ClientActivityLog);
